const styles = {
    weekday: {
        width: "32px",
        fontFamily: "IBM Plex Sans",
        marginLeft: "7px",
        marginRight: "7px",
        padding: "0",
        textAlign: "center",
        paddingTop: "4px"
    }
}

export default styles;
